import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import {SearchFilterItem} from "../models/SearchFilterItem";

@Injectable()
export class ClearFilterService {
  // Observable string sources
  private clearFilterAnnouncedSource = new Subject<SearchFilterItem>();
  private clearFilterConfirmedSource = new Subject<SearchFilterItem>();
  // Observable string streams
  clearFilterAnnounced$ = this.clearFilterAnnouncedSource.asObservable();
  clearFilterConfirmed$ = this.clearFilterConfirmedSource.asObservable();
  // Service message commands
  announceclearFilter(item: SearchFilterItem) {
    this.clearFilterAnnouncedSource.next(item);
  }
  confirmclearFilter(item: SearchFilterItem) {
    this.clearFilterConfirmedSource.next(item);
  }
}
